import { Services } from "appworks/services/services";
import { RandomRangeInt } from "appworks/utils/math/random";
import { FooterComponent } from "slotworks/components/footer/footer-component";

export class GamevyFooterComponent extends FooterComponent {

    public static infoMessages: string[] = [
        "footer_info_1",
        "footer_info_2"
    ];

    public showNoWin() {
       // do nothing
    }

    public showSpinStart(betValue: number) {
        const random = RandomRangeInt(0, 1);
        const message = Services.translations.get(GamevyFooterComponent.infoMessages[random]);
        this.setText(message);
    }

    public showBonusWin() {
        this.setText(Services.translations.get("footer_bonus_awarded"));
    }
}
